<template>
  <section class="page-faq">
    <header>
      <header-app
        :is-mobile="isMobile"
      />
    </header>
    <main class="main-faq">
      <h2 class="main-faq__title">{{ $t('faq.title') }}</h2>
      <div class="accordion" role="tablist">
        <b-card no-body v-for="item in $t('faq.list')" :key="item.id">
          <b-card-header role="tab">
            <a v-b-toggle="item.id" :href="`#${item.id}`" @click.prevent>
              {{ item.question }}
              <font-awesome-icon icon="chevron-down" />
            </a>
          </b-card-header>
          <b-collapse :id="item.id" :visible="item.id === $route.hash.substring(1)"
                      accordion="faq" role="tabpanel">
            <b-card-body>
              <b-card-text>{{ item.answer }}</b-card-text>
            </b-card-body>
          </b-collapse>
          <div class="collapse__background"></div>
          <div class="collapse__delimiter"></div>
        </b-card>
      </div>
    </main>
  </section>
</template>

<script>
import HeaderApp from '../layouts/HeaderApp/HeaderApp';

export default {
  name: 'PageFaq',
  components: {
    HeaderApp,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$route.hash) {
        const el = document.querySelector(this.$route.hash).closest('.card');
        if (el) {
          el.scrollIntoView({ block: 'center' });
        }
      }
    });
  },
};
</script>

<style lang="scss" scoped>
  .page-faq {
    background-color: var(--backgound-color);
  }
  .main-faq {
    box-sizing: border-box;
    margin: 0 auto;
    max-width: 700px;
    padding: 45px 20px 100px;
  }
  .main-faq__title {
    font-size: 36px;
    font-weight: 400;
    margin-bottom: 30px;
    padding-top: 50px;
  }
  .accordion {

    .card {
      background: none;
      border: none;
      border-radius: 4px;
      margin-top: -1px;
    }
    .card-header {
      background: none;
      border: none;
      padding: 0;
      position: relative;
      z-index: 1;

      a {
        align-items: center;
        color: var(--btn-primary);
        display: flex;
        font-size: 18px;
        padding: 25px 50px;
        position: relative;
        text-decoration: none;
        text-align: left;
        width: 100%;

        svg {
          height: 0.9em;
          margin-left: auto;
          transition: .35s ease;
        }
        &.not-collapsed {
          svg {
            transform: rotate(180deg);
          }
        }
      }
    }
    .collapse__delimiter {
      background-color: #e5e7f3;
      bottom: 0;
      content: '';
      height: 1px;
      left: 50px;
      position: absolute;
      transition: .25s ease;
      right: 50px;
    }
    .collapse__background {
      background-color: #e5e7f3;
      display: block;
      height: 100%;
      opacity: 0;
      position: absolute;
      top: 0;
      transition: .25s ease;
      width: 100%;

    }
    .collapse {
      &.show ~ .collapse__background {
        opacity: 1;
      }
      &.show ~ .collapse__delimiter {
        opacity: 0;
      }
    }
    .card-body {
      padding: 0 50px 35px;
      position: relative;
      text-align: left;
      z-index: 1;
    }
  }
  @media screen and (max-width: $breakpoint-sm) {
    .img-404 {
      margin-top: 15%;
      margin-bottom: 10%;
    }
    .message-404 {
      padding: 0 32px;
    }
  }
</style>
